import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class LLPLotsSearchModel extends BaseModel {
  lot_no = null;
  title = null;
  bidder_uuid = null;
  highest_bid = false;

  rules = {};

  attributeLabels = {
    lot_no: i18n.t('Lot No'),
    title: i18n.t('Lot Title'),
    bidder_uuid: i18n.t('Bidder'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    return data;
  }
}
